/* Generated by tools/build_sections.py from brand/reveal.js.
   Edit there, not here. */
(function(){if(window.__efEnergy_reveal)return;window.__efEnergy_reveal=1;
/* EcoFlow Home Energy — reveal + scene runtime.
 *
 * WHY THIS FILE EXISTS
 * components.css declares the reveal with the HIDDEN state as the base:
 *   .ef-in { opacity: 0; transform: translateY(...) }
 *   .ef-in.is-in { opacity: 1; transform: none }
 * Nothing in the system added `.is-in`. With 311 `.ef-in` elements across the
 * nineteen pages, that is not a missing animation — it is a blank site. The
 * stylesheet's own no-JS escape is `html.no-js`, so the contract is:
 *
 *   the shell ships <html class="no-js">, and THIS FILE takes it off.
 *
 * Which means a parse error here leaves the page readable rather than empty.
 * That ordering is deliberate: `no-js` comes off first, before any observer is
 * built, so even an unsupported API further down cannot hide the content.
 *
 * It also drives the pinned scenes. `data-ef-move|scale|fade="from,to"` are
 * interpolated across the progress of the enclosing [data-ef-scene], which is
 * a ~220-330vh .ef-pin track with a sticky .ef-pin__view inside it.
 *
 * Exposes window.EcoFlowEnergy.reveal for manual control.
 */
(function () {
  "use strict";

  var doc = document, root = doc.documentElement;

  /* 1. Content first. Everything below is enhancement; this line is not. */
  root.classList.remove("no-js");

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  var reduced = window.matchMedia &&
                window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function revealAll() {
    each(doc.querySelectorAll(".ef-in, .ef-in-group"), function (el) {
      el.classList.add("is-in");
    });
  }

  /* 2. The reveal. No IntersectionObserver (or reduced motion) means show
   *    everything at once — never means show nothing. */
  var io = null;
  function startReveal() {
    if (reduced || !("IntersectionObserver" in window)) { revealAll(); return; }
    io = new IntersectionObserver(function (entries) {
      each(entries, function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-in");
        io.unobserve(e.target);          /* one-shot: a reveal does not undo */
      });
    }, {
      /* Fire slightly before the element's top edge arrives, so the motion is
         finishing as it reaches comfortable reading position rather than
         starting there. A 0.01 threshold catches elements taller than the
         viewport, which a 0.2 threshold would never satisfy. */
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.01
    });
    each(doc.querySelectorAll(".ef-in, .ef-in-group"), function (el) {
      io.observe(el);
    });
  }

  /* 3. The pinned scenes. One rAF-throttled pass over the scenes that are
   *    actually on screen; a page with no [data-ef-scene] attaches nothing. */
  var scenes = [], ticking = false;

  function parsePair(v, fallback) {
    var p = String(v).split(",");
    var a = parseFloat(p[0]), b = parseFloat(p[1]);
    return [isNaN(a) ? fallback : a, isNaN(b) ? fallback : b];
  }

  function collectScenes() {
    scenes = [];
    each(doc.querySelectorAll("[data-ef-scene]"), function (sc) {
      var parts = [];
      each(sc.querySelectorAll("[data-ef-move],[data-ef-scale],[data-ef-fade]"), function (el) {
        parts.push({
          el: el,
          move:  el.hasAttribute("data-ef-move")  ? parsePair(el.getAttribute("data-ef-move"), 0) : null,
          scale: el.hasAttribute("data-ef-scale") ? parsePair(el.getAttribute("data-ef-scale"), 1) : null,
          fade:  el.hasAttribute("data-ef-fade")  ? parsePair(el.getAttribute("data-ef-fade"), 1) : null
        });
      });
      if (parts.length) scenes.push({ track: sc, parts: parts });
    });
  }

  function apply() {
    ticking = false;
    var vh = window.innerHeight || root.clientHeight;
    for (var i = 0; i < scenes.length; i++) {
      var s = scenes[i], r = s.track.getBoundingClientRect();
      /* Progress of the sticky view through its track: 0 when the track's top
         reaches the viewport top, 1 when its bottom does. Clamped, so a part
         holds its end state instead of flying off once the scene is passed. */
      var span = r.height - vh;
      var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span))
                       : (r.top <= 0 ? 1 : 0);
      for (var j = 0; j < s.parts.length; j++) {
        var q = s.parts[j], t = [];
        if (q.move)  t.push("translate3d(0," + (q.move[0]  + (q.move[1]  - q.move[0])  * p).toFixed(2) + "px,0)");
        if (q.scale) t.push("scale(" +         (q.scale[0] + (q.scale[1] - q.scale[0]) * p).toFixed(4) + ")");
        if (t.length) q.el.style.transform = t.join(" ");
        if (q.fade)  q.el.style.opacity = (q.fade[0] + (q.fade[1] - q.fade[0]) * p).toFixed(3);
      }
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  function startScenes() {
    /* Reduced motion keeps the END state — the design's composition at rest —
       rather than the start state, which is mid-animation and often offset. */
    collectScenes();
    if (!scenes.length) return;
    if (reduced) {
      for (var i = 0; i < scenes.length; i++) {
        for (var j = 0; j < scenes[i].parts.length; j++) {
          var q = scenes[i].parts[j], t = [];
          if (q.move)  t.push("translate3d(0," + q.move[1] + "px,0)");
          if (q.scale) t.push("scale(" + q.scale[1] + ")");
          if (t.length) q.el.style.transform = t.join(" ");
          if (q.fade)  q.el.style.opacity = String(q.fade[1]);
        }
      }
      return;
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    apply();
  }

  function start() { startReveal(); startScenes(); }

  if (doc.readyState === "loading") {
    doc.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  window.EcoFlowEnergy = window.EcoFlowEnergy || {};
  window.EcoFlowEnergy.reveal = {
    refresh: function () { collectScenes(); apply(); startReveal(); },
    revealAll: revealAll
  };
})();

})();
